import React from 'react';

import Textfield from '@atlaskit/textfield';

export default function TextFieldAppearanceSubtle(): React.JSX.Element {
	return <Textfield appearance="subtle" label="Subtle" placeholder="" />;
}
